<div id="content-desktop">
  <header>


    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 1%; padding-bottom: 1%; width: 10% " class="img-responsive">
            <img src="../../../assets/D URL 2.png" style="width: 40%; position: absolute; top: 25%; " class="img-responsive" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../../assets/D Beef Phone.png" style="width: 15%; display: block; margin-left: auto; top: 50%;" class="right" />
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #d64038 ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold">Notice/FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File A Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact-information']" style="color:white; font-weight: bold ">Contact Information</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>


  </header>
</div>


<div class="container" style="border:1px solid #bebaba">
  <br />
  <h3><b>Contact Information</b></h3>
  <br />
  <p>
    If after reviewing the information included on this website you still have questions about the Settlement, please contact the Settlement Administrator directly using the contact information below.<br /><br />
  </p>
  <p style="text-align:center">
    DPP Beef Litigation Helpline: 877-331-0717<br /><br />

    By email: <a href="mailto:info@BeefDirectPurchaserSettlement.com">info@BeefDirectPurchaserSettlement.com</a><br />
    Or in writing to:<br />
    <i>DPP Beef Litigation</i><br />
    c/o A.B. Data, Ltd.<br />
    PO Box 173066<br />
    Milwaukee, WI 53217<br /><br />
  </p>

  <p>
    Remember to include “DPP Beef Litigation” on any correspondence, envelope, and/or subject line.
  </p>
</div>








